/**
 * User-visible labels for the five create-module ingest kinds (text field, URL,
 * upload, YouTube, Google Doc).
 *
 * WHAT / WHY:
 * - One string table shared by the /try tab bar and homepage sample cards so
 *   marketing copy cannot drift from product terminology.
 *
 * CALLED BY:
 * - `src/client/try-mode-tabs.ts` (tab button text)
 * - `src/ssr/landing.ts` (sample-card eyebrow)
 */

export const TryContentTypeLabel = Object.freeze({
  TEXT: 'Text',
  URL: 'URL',
  FILE: 'File',
  YOUTUBE: 'YouTube',
  GOOGLE_DOC: 'Google Doc'
} as const);

export type TryContentTypeLabelValue = (typeof TryContentTypeLabel)[keyof typeof TryContentTypeLabel];
